var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isComponentReady)?_c(_vm.currentComponent,_vm._b({tag:"component"},'component',_vm.componentProps,false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }